export default __webpack_public_path__ + "static/media/home-shop-classic-03.33397472.png";